import React from "react";
import toast from "react-hot-toast";
import { authApiService } from "../../../../api/api";
import { IProduct } from "../../../../types/product.type";
import BlueButton from "../../../buttons/BlueButton/BlueButton";
import ModalBottomButtons from "../buttons/ModakBottomButtons/ModalBottomButtons";
import ViewInput from "../inputs/ViewInput/ViewInput";
import styles from "./styles.module.scss";

interface Props {
  product: IProduct;
  onClose: () => void;
  onPressEdit: () => void;
  onApply: () => void;
}

const ViewProductForm: React.FC<Props> = (props) => {
  const takeCopy = async () => {
    try {
      const response = await authApiService.copyProduct(props.product.id);
      if (response) {
        toast.success("Product copied successfully");
        props.onApply();
        return;
      }
    } catch (err: any) {
      toast.error(err.response.data.message);
      console.error(err);
    }
  };

  return (
    <div>
      <div className={styles.form}>
        <ViewInput title="Бренд" value={props.product.brand.name} />
        <ViewInput title="Категорія" value={props.product.category.name} />
        <ViewInput
          title="Тип продукту"
          value={props.product.productType.name}
        />
        <ViewInput
          title="Вартість (роздріб / опт)"
          value={`${props.product.price} / ${props.product.wholeSalePrice}`}
        />
        <ViewInput
          title="Conditions"
          value={props.product.tags.map((item) => item.name).join(", ")}
          isBig
        />

        <ViewInput title="Обʼєм" value={props.product.capacity} />
        <ViewInput
          title="Опис"
          value={props.product.description}
          isBig={true}
        />
        <ViewInput
          title="Короткий опис"
          value={props.product.shortDescription}
          isBig={true}
        />
        <ViewInput
          title="Як використовувати"
          value={props.product.howToUse}
          isBig={true}
        />
        <ViewInput
          title="Інгредієнти"
          value={props.product.fullIngredientsList}
          isBig={true}
        />
        <ViewInput title="Тип шкіри" value={props.product.skinType} />
        <BlueButton title="Зробити копію" onClick={takeCopy} isBigButton />
      </div>
      <ModalBottomButtons
        backTitle="Назад"
        onPressBack={props.onClose}
        applyTitle="Редагувати"
        onPressApply={props.onPressEdit}
      />
    </div>
  );
};

export default ViewProductForm;
